// @flow
import type { CreateRecipeApi, UpdateRecipeApi } from './types';
import { httpDelete, httpGet, httpPost, httpPut } from '~/core/api/helpers/helpers.api';

import url from 'url';

export function getRecipes() {
    const getRecipesURL = url.format({
        pathname: '/recipes'
    });

    return httpGet(getRecipesURL);
}

export function createRecipe(newRecipe: CreateRecipeApi) {
    const createRecipeURL = url.format({
        pathname: '/recipes'
    });

    return httpPost(createRecipeURL, newRecipe);
}

export function deleteRecipe(recipeId: string) {
    const deleteRecipeURL = url.format({
        pathname: `/recipes/${recipeId}`
    });

    return httpDelete(deleteRecipeURL);
}

export function updateRecipe(recipe: UpdateRecipeApi) {
    const updateRecipeURL = url.format({
        pathname: `/recipes/${recipe.id}`
    });

    return httpPut(updateRecipeURL, recipe);
}



// WEBPACK FOOTER //
// ./src/core/state/recipes/api.js